import React, { useEffect, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import Pencil from '../../../../images/pencil.png';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { mapToOption } from '../../../../utlis';
import { useVendorForm } from './../VendorFormContext';

const options = [
  { value: '', text: '--Choose an option--' },
  { value: 'option1', text: 'option1' },
  { value: 'option2', text: 'option2' },
  { value: 'option3', text: 'option3' },
  { value: 'option4', text: 'option4' },
  { value: 'option5', text: 'option5' },
];

const CompanyPreference = () => {
  const navigate = useNavigate();
  const { formData, updateFormData, saveVendorData, saveAllChanges, hasUnsavedChanges, isCreating, isSaving, markTabComplete } = useVendorForm();
  // Always provide all fields as strings or booleans for defaultValues
  const companyPref = formData?.companyPreference || {};
  const defaultValues = {
    contactMethod: String(companyPref.contactMethod ?? ''),
    email: String(companyPref.email ?? ''),
    followupEmail: String(companyPref.followupEmail ?? ''),
    bulkEmail: companyPref.bulkEmail ?? false
  };

  const {
    register,
    handleSubmit,
    reset,
    watch,
    formState: { errors, isDirty },
  } = useForm({
    defaultValues,
    mode: 'onChange',
    shouldUnregister: true,
  });
  const referenceData = useSelector((state) => state.reference);

  // Only reset if defaultValues change from outside (not on every keystroke)
  const prevDefaults = useRef(defaultValues);
  useEffect(() => {
    if (JSON.stringify(prevDefaults.current) !== JSON.stringify(defaultValues)) {
      reset(defaultValues);
      prevDefaults.current = defaultValues;
    }
  }, [defaultValues, reset]);

  // Watch for changes and auto-sync to context for global change detection
  // Skip first sync — resetVendorData already populated context
  const watched = watch();
  const prevWatchedData = useRef(watched);
  const isFirstSync = useRef(true);
  useEffect(() => {
    if (JSON.stringify(prevWatchedData.current) !== JSON.stringify(watched)) {
      if (!isFirstSync.current) {
        updateFormData('companyPreference', watched);
      }
      prevWatchedData.current = watched;
      isFirstSync.current = false;
    }
  }, [watched, updateFormData]);

  const onSubmit = async (data) => {
    updateFormData('companyPreference', data);
    saveVendorData('companyPreference', data);
    reset(data); // Reset with current data to clear dirty state
  };

  return (
    <div className="w-full h-full">
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="flex flex-col gap-y-6 mt-5 text-sm font-normal text-text-hint"
      >
        <div className="grid grid-cols-4 gap-3">
          <div className="">
            <label className="">Contact Method<span className="text-danger-500">*</span></label>
            <select
              {...register('contactMethod', { required: 'Contact method is required' })}
              className={`flex justify-center items-center focus:ring-0 px-3 py-2 mt-1 border rounded-lg outline-none w-full ${errors.contactMethod ? 'border-danger-500' : 'border-neutral-500'}`}
            >
              {mapToOption(referenceData.contactmethods?.contact, 'method').map((option) => (
                <option className="" key={option.value} value={option.value}>
                  {option.text}
                </option>
              ))}
            </select>
            {errors.contactMethod && (
              <span className="text-danger-500">{errors.contactMethod.message}</span>
            )}
          </div>
        </div>
        <div className="grid grid-cols-4 gap-3">
          <div className="">
            <label className="">Email<span className="text-danger-500">*</span></label>
            <div className={`flex justify-center items-center px-3 py-2 mt-1 border rounded-lg ${errors.email ? 'border-danger-500' : 'border-neutral-500'}`}>
              <input
                {...register('email', {
                  required: 'Email is required',
                  maxLength: { value: 50, message: 'Email must not exceed 50 characters' },
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: 'Invalid email address',
                  },
                })}
                placeholder="youremail@gmail.com"
                maxLength={50}
                className={`outline-none w-full`}
              />
              <img src={Pencil} alt="pencil" />
            </div>
            {errors.email && <span className="text-danger-500">{errors.email.message}</span>}
          </div>
          <div className="">
            <label className="">Follow Up Email<span className="text-danger-500">*</span></label>
            <div className={`flex justify-center items-center px-3 py-2 mt-1 border rounded-lg ${errors.followupEmail ? 'border-danger-500' : 'border-neutral-500'}`}>
              <input
                {...register('followupEmail', {
                  required: 'Follow up email is required',
                  maxLength: { value: 15, message: 'Follow-up email must not exceed 15 characters' },
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: 'Invalid email address',
                  },
                })}
                placeholder="youremail@gmail.com"
                maxLength={15}
                className={`outline-none w-full`}
              />
              <img src={Pencil} alt="pencil" />
            </div>
            {errors.followupEmail && (
              <span className="text-danger-500">{errors.followupEmail.message}</span>
            )}
          </div>
          <div className="flex flex-col space-y-2">
            <label className="text-sm font-semibold">Bulk Email</label>
            <div className="mt-1">
              <input
                {...register('bulkEmail')}
                type="checkbox"
                className="w-5 h-5 text-blue-500 focus:ring-blue-500"
              />
            </div>
          </div>
        </div>
        <div className="grid grid-cols-4 gap-3">
          {/* <div className="">
            <label className="">Phone</label>
            <div className="flex justify-center items-center px-3 py-2 mt-1 border border-neutral-500 rounded-lg">
              <input
                {...register("phone", { required: "Phone is required" })}
                placeholder="Phone"
                className="outline-none w-full"
              />
              <img src={Pencil} alt="pencil" />
            </div>
            {errors.phone && <span className="text-danger-500">{errors.phone.message}</span>}
          </div> */}
          {/* <div className="">
            <label className="">Fax</label>
            <div className="flex justify-center items-center px-3 py-2 mt-1 border border-neutral-500 rounded-lg">
              <input
                {...register("fax", { required: "Fax is required" })}
                placeholder="Fax"
                className="outline-none w-full"
              />
              <img src={Pencil} alt="pencil" />
            </div>
            {errors.fax && <span className="text-danger-500">{errors.fax.message}</span>}
          </div> */}
        </div>
      </form>
      <div className="w-full py-10 px-8 flex justify-end items-center gap-2">
        <button
          type="button"
          onClick={() => navigate("/sales/vendors/details/company-profile")}
          className="text-secondary-700 border border-secondary-700 py-2 px-5 rounded-full text-base bg-white hover:bg-gray-50 transition"
        >
          Previous
        </button>
        {!isCreating && hasUnsavedChanges && (
          <button
            type="button"
            disabled={isSaving}
            onClick={saveAllChanges}
            className="text-white bg-green-600 py-2 px-5 rounded-full text-base hover:bg-green-700 transition disabled:opacity-50"
          >
            {isSaving ? 'Saving...' : 'Save'}
          </button>
        )}
        <button
          type="button"
          onClick={handleSubmit((data) => {
            updateFormData("companyPreference", data);
            if (isCreating) markTabComplete("company-preference");
            navigate("/sales/vendors/details/billing-terms");
          })}
          className="text-white bg-secondary-700 py-2 px-5 rounded-full text-base"
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default CompanyPreference;
